import styled from 'styled-components';

type TResponsive = {
  isMobile?: boolean;
  isDesktop?: boolean;
  isMediumSize?: boolean;
};

export const Container = styled.div<TResponsive>`
  position: absolute;

  .bubble_01,
  .bubble_02,
  .bubble_03,
  .bubble_04,
  .bubble_05 {
    position: relative;
    transition: 0.3s all ease-in;
  }

  .bubble_01 {
    left: 170px !important;
    top: -130px !important;
    width: 84%;
    transform: rotate(-96deg);
    filter: brightness(0) saturate(100%) invert(97%) sepia(12%) saturate(507%) hue-rotate(345deg) brightness(108%)
      contrast(103%);

    &:hover {
      transform: rotate(-156deg);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 354px !important;
      top: -265px !important;
      width: 100%;
      transform: rotate(-146deg);
    `}
  }

  .bubble_02 {
    left: -148px !important;
    top: -114px !important;
    width: 75% !important;
    filter: brightness(0) saturate(100%) invert(87%) sepia(18%) saturate(991%) hue-rotate(190deg) brightness(108%)
      contrast(101%);

    &:hover {
      transform: rotate(55deg);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 61px !important;
      top: -140px !important;
      width: 35% !important;
      `}
  }

  .bubble_03 {
    left: 1px !important;
    top: 247px !important;
    width: 85% !important;
    transform: rotate(90deg);
    filter: brightness(0) saturate(100%) invert(100%) sepia(37%) saturate(3066%) hue-rotate(293deg) brightness(118%)
      contrast(108%);

    &:hover {
      transform: rotate(70deg);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 139px !important;
      top: 154px !important;
      width: 50% !important;
    `}
  }

  .bubble_04 {
    left: 83px !important;
    top: 665px !important;
    width: 72% !important;
    transform: rotate(165deg);
    filter: brightness(0) saturate(100%) invert(84%) sepia(21%) saturate(441%) hue-rotate(197deg) brightness(105%)
      contrast(104%);

    &:hover {
      transform: translateZ(20px);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 375px !important;
      top: 354px !important;
      width: 53% !important;
      `}
  }
`;

export const FigureBubble = styled.div``;
